import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { isSuccessResponse } = {}) => ({
  centered: { textAlign: 'center' },
  container: {
    alignItems: 'center',
    display: 'flex',
    height: 'calc(100vh - 250px)',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '0 auto',
    width: 510,
    [theme.breakpoints.down('lg')]: {
      width: 530,
    },
    [theme.breakpoints.down('md')]: {
      width: 230,
    },
  },
  icon: {
    alignItems: 'center',
    background: '#F4F4F4',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    height: 120,
    width: 120,
    '& svg': {
      cursor: 'initial',
      ...(!isSuccessResponse && {
        height: 70,
        width: 70,
      }),
    },
  },
}));
